<script setup>
import { ref, computed } from 'vue';
import FormButton from '@/components/Atoms/FormButton.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconBookOpen from '@/components/icon/IconBookOpen.vue'
import IconPlay from '@/components/icon/IconPlay.vue'
import ModalBox from '@/components/modals/ModalBox.vue'

const props = defineProps({
  howItWorksLink: {
    type: String,
    required: true,
  },
  howItWorksText: {
    type: String,
    required: true,
  },
  tutorialLink: {
    type: String,
    required: true,
  },
});

const showTutorialModal = ref(false)

const playerUrl = computed(() => {
  const string = props.tutorialLink;
  if (string.includes('youtube')) return string;
  return `https://app.supademo.com/embed/${string}`;
})

</script>

<template>
  <div class="flex flex-none flex-wrap items-center gap-x-4 gap-y-1 w-fit">
    <a class="text-tiny text-surface-8 hover:text-white hover:no-underline inline-flex gap-2 items-center text-nowrap min-w-0 w-fit"
      target="_blank" :href="howItWorksLink">
      <icon-base class="shrink-0" fill="none">
        <icon-book-open />
      </icon-base>
      {{ howItWorksText }}
    </a>
    <FormButton type="link" customClasses="text-surface-8 hover:text-white text-tiny inline-flex gap-2 items-center min-w-0 w-fit"
      @click="showTutorialModal = true">
      <icon-base class="" fill="none">
        <icon-play />
      </icon-base>
      Watch a tutorial
    </FormButton>
    <ModalBox v-model="showTutorialModal" headerClass="hidden" size="lg">
      <iframe class="w-full h-full aspect-video" :src="playerUrl" title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
        ></iframe>
    </ModalBox>
  </div>
</template>

<style scoped></style>